import { Box, Container, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import portalSettingsManager from "utils/portalSettingsManager";

export const Layout = ({
  header,
  footer,
  main,
}: {
  header: React.ReactNode;
  footer: React.ReactNode;
  main: React.ReactNode;
}): React.ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const mainContentOffset = portalSettingsManager?.application?.features?.enableIBFFlow
    ? "104px"
    : "70px";
  const isFullScreen = () => {
    return location.pathname.toLowerCase().indexOf("/player") !== -1;
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {header && (
        <Box
          position={!isMobile ? "fixed" : "unset"}
          top="0"
          left="0"
          right="0"
          height={{
            xs: portalSettingsManager?.application?.features?.enableIBFFlow ? "62px" : "50px",
            sm: portalSettingsManager?.application?.features?.enableIBFFlow ? "104px" : "70px",
          }}
          zIndex="999"
          style={{ backgroundColor: "#ffffff" }}
          component="header"
          role="banner"
          aria-label={t("aria_label_header")}
        >
          {header}
        </Box>
      )}
      <Box
        flex="1"
        marginTop={
          isFullScreen()
            ? { xs: "0px", sm: "0px", md: "0px" }
            : {
                xs: "0px",
                sm: "0px",
                md: mainContentOffset,
              }
        }
        style={{ scrollMarginTop: !isMobile && !isFullScreen() ? mainContentOffset : "0px" }}
        overflow="hidden"
        role="main"
        component="main"
        id="main-content"
        tabIndex={-1}
        aria-label={t("aria_label_main_content")}
      >
        {main}
      </Box>
      <Box
        borderTop="1px solid #c9c9c9"
        component="footer"
        role="contentinfo"
        aria-label={t("aria_label_footer")}
      >
        <Container>{footer}</Container>
      </Box>
    </Box>
  );
};
